import { useEditor } from '@craftjs/core';
import { UniLink } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/UniLink';
import {
  Chip,
  ChipColor,
} from '@lmt/unicorn-shared/app/components/common/ui-kit/Chip';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React from 'react';
import { ButtonColor } from '../../common/ui-kit/buttons/Button';
import { ExpansionContainer } from './blocks/ExpansionContainer';

import styles from './SettingsPanel.module.scss';

export const SettingsPanel = () => {
  const { actions, selected } = useEditor((state, query) => {
    const selectedNodes = state.events.selected;
    if (!selectedNodes || selectedNodes.size === 0)
      return {
        selected: undefined,
      };
    const currentNodeId = selectedNodes.values().next().value;

    if (!currentNodeId)
      return {
        selected: undefined,
      };

    const selected = {
      id: currentNodeId,
      name: state.nodes[currentNodeId].data.name,
      settings:
        state.nodes[currentNodeId].related &&
        state.nodes[currentNodeId].related.settings,
      isDeletable: query.node(currentNodeId).isDeletable(),
    };
    return {
      selected,
    };
  });

  const i18next = useScopedTranslation('editor.settings');

  if (!selected) {
    return null;
  }

  return (
    <ExpansionContainer header={i18next.t('header')}>
      <div className={styles.container}>
        <div className={styles.controls}>
          <Chip title={selected.name} color={ChipColor.Primary} />
          {selected.isDeletable ? (
            <UniLink
              className={styles.deleteLink}
              title={i18next.t('delete_button')}
              color={ButtonColor.Danger}
              onClick={() => {
                actions.delete(selected.id);
              }}
            />
          ) : null}
        </div>
        {selected.settings && React.createElement(selected.settings)}
      </div>
    </ExpansionContainer>
  );
};
